if (!customElements.get('dyo-slider-option')) {
  class DYOSliderOption extends HTMLElement {
    constructor() {
      super();
      this.desktopWidth = 1025;
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      if (!window.Swiper) {
        console.log('Swiper instance does not exist');

        return null;
      }

      this.swiperInstance = new window.Swiper(this, {
        slidesPerView: 3,
        preventInteractionOnTransition: true,
        spaceBetween: 2,
        slidesOffsetAfter: 2,
        slidesOffsetBefore: 2,
        watchOverflow: true,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          1025: {
            centeredSlides: false,
            slidesPerView: 'auto',
            spaceBetween: 4,
            slidesOffsetAfter: 4,
            slidesOffsetBefore: 4,
            centerInsufficientSlides: true,
            loop: true,
          },
        },
        on: {
          slideChange: function (e) {
            const activeSlide = e.slides[e.activeIndex];

            // 2. Remove the class from all slides' children first (optional but recommended)
            e.slides.forEach((slide) => {
              const child = slide.querySelector('.pdp-dyo-material-card');
              if (child) child.classList.remove('text-shown');
            });

            // 3. Add the class to the child of the current active slide
            const activeChild = activeSlide.querySelector(
              '.pdp-dyo-material-card',
            );

            if (activeChild) {
              activeChild.classList.add('text-shown');
            }
          },
        },
      });
    }

    destroySwiper() {
      if (this.swiperInstance) {
        try {
          if (this.swiperInstance.destroyed) {
            console.info('Swiper already destroyed');

            this.swiperInstance = null;
            return null;
          }
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        } catch (error) {
          console.error('Error destroying Swiper:', error);
          this.swiperInstance = null; // Fallback
        }
      } else {
        console.log('No Swiper instance to destroy');
      }
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.destroySwiper();
      }
    }
  }

  customElements.define('dyo-slider-option', DYOSliderOption);
}
